export default "/_next/static/chunks/fonts/AntDesign-16deec9a05fa7f84594b52401ff7a224.ttf";